module.exports = __webpack_public_path__ + "static/splash-8972ae56e26665061db511c314164776.mp4";